import { useTranslation } from 'next-i18next'
import React, { FunctionComponent } from 'react'
import { useSummaryRoute } from '../../config/router'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import {
  ADDRESS_1,
  ADDRESS_2,
  AREA_2,
  COUNTRY_CODE,
  FULL_CONTACT_NAME,
  IS_PREFERRED_ADDRESS,
  MOBILE,
  POSTCODE,
  ShippingAddressFormData,
  STATE,
  SUBURB,
} from '../../model'
import { saveShippingAddress, useAppDispatch, useAppRouter, useCountry } from '../../state'
import { ShippingAddressForm } from '../ShippingAddressForm/ShippingAddressForm'

interface NewShippingAddressFormProps {
  editMode?: boolean
  id?: number
}

export const NewShippingAddressForm: FunctionComponent<NewShippingAddressFormProps> = (): JSX.Element => {
  const router = useAppRouter()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const country = useCountry()
  const summaryRoute = useSummaryRoute()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const initialFormValues = {
    [FULL_CONTACT_NAME]: '',
    [MOBILE]: '',
    [COUNTRY_CODE]: country,
    [ADDRESS_1]: '',
    [ADDRESS_2]: '',
    [AREA_2]: '',
    [POSTCODE]: '',
    [STATE]: '',
    [SUBURB]: '',
    [IS_PREFERRED_ADDRESS]: false,
  }

  const onSave = async (formData: ShippingAddressFormData): Promise<void> => {
    const shippingAddress = {
      name: formData[FULL_CONTACT_NAME],
      countryCode: formData[COUNTRY_CODE],
      address1: formData[ADDRESS_1],
      address2: formData[ADDRESS_2],
      area2: formData[AREA_2],
      suburb: formData[SUBURB],
      postcode: formData[POSTCODE],
      state: formData[STATE],
      phoneNumber: formData[MOBILE],
      preferred: formData[IS_PREFERRED_ADDRESS],
    }

    await dispatch(saveShippingAddress(shippingAddress))
    logEvent('Viewed Save Add New Shipping Address Check', {
      addressCountryCode: shippingAddress.countryCode,
      addressPostcode: shippingAddress.postcode,
      addressState: shippingAddress.state,
      checkoutCountryCode: country,
    })
    router.push(summaryRoute)
  }

  const saveButtonLabel = t('addNewAddress:saveAddressButtonLabel')

  return <ShippingAddressForm saveButtonLabel={saveButtonLabel} onSaveHandler={onSave} initialFormValues={initialFormValues} />
}
